<template>
  <BgImageLayout title="Subscriptions Feedback">
    <q-table :data="subscriptions || []" :columns="columns" :pagination="pagination" row-key="id">
      <template #top-left>
        {{ formatName(stakeholderSubscriptions.stakeholder) }}
      </template>

      <template #top-right>
        <q-btn :disabled="!subscriptions" color="tertiary" size="sm" @click="save">
          Save
        </q-btn>
      </template>

      <template #header-cell="{col}">
        <q-th v-if="col.name === 'decision' && subscriptions" class="decision-column text-faded">
          <Grid gtc="1fr 1fr">
            <q-checkbox
              :value="colCheckBoxes"
              :true-value="true"
              :false-value="''"
              label="Yes to all"
              dense
              @input="toggleColCheckboxes(true)"
            />
            <q-checkbox
              :value="colCheckBoxes"
              :true-value="false"
              :false-value="''"
              label="No to all"
              dense
              @input="toggleColCheckboxes(false)"
            />
          </Grid>
        </q-th>
        <q-th v-else :class="col.__thClass" class="text-faded">{{ col.label }}</q-th>
      </template>

      <template #body-cell-price="{row}">
        <td>
          {{ formatPrice(row.price) }} <small>{{ row.currency }}</small>
        </td>
      </template>

      <template #body-cell-share="{row, col}">
        <td :class="`text-${col.align}`">
          {{ formatPrice(row.share) }} <small>{{ row.currency }}</small>
        </td>
      </template>

      <template #body-cell-decision="{row}">
        <q-td>
          <Grid gtc="1fr 1fr">
            <q-checkbox
              :value="row.decision"
              :val="true"
              :true-value="true"
              :false-value="''"
              label="Yes, renew"
              dense
              @input="toggleCellCheckboxes(row, true)"
            />
            <q-checkbox
              :value="row.decision"
              :val="false"
              :true-value="false"
              :false-value="''"
              label="No, don't renew"
              dense
              @input="toggleCellCheckboxes(row, false)"
            />
          </Grid>
        </q-td>
      </template>

      <template #no-data>
        <div class="full-width row flex-center text-secondary-5 q-gutter-sm">
          <q-icon size="2em" name="fas fa-check" />
          <span class="text-body-1"> You have completed the task! </span>
        </div>
      </template>
    </q-table>
  </BgImageLayout>
</template>

<script>
import { cloneDeep, get } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'LmPageStakeholderResponses',

  data() {
    return {
      subscriptions: null,
      pagination: {
        rowsPerPage: 30
      },
      columns: [
        {
          name: 'subscription',
          label: 'Subscription',
          align: 'left',
          field: 'name'
        },

        {
          name: 'publisher',
          label: 'Publisher',
          align: 'left',
          field: row => row.publisher.name
        },

        {
          name: 'start_date',
          label: 'Start Date',
          align: 'left',
          field: 'start_date'
        },

        {
          name: 'end_date',
          label: 'End Date',
          align: 'left',
          field: 'end_date'
        },

        {
          name: 'price',
          label: 'Total Price',
          align: 'left',
          field: 'price'
        },

        {
          name: 'department',
          label: 'Department',
          align: 'left',
          field: row => get(row, 'department.name', 'N/A')
        },

        {
          name: 'cancellation_deadline',
          label: 'Deadline',
          align: 'left',
          field: 'cancellation_deadline',
          format: val => val ?? 'N/A'
        },

        {
          name: 'stake',
          label: 'Department stake',
          align: 'right',
          field: 'stake',
          format: val => (+val).toFixed(2)
        },

        {
          name: 'share',
          label: 'Your share',
          align: 'right',
          field: 'share'
        },

        {
          name: 'decision',
          label: 'Decision',
          align: 'left',
          field: 'decision'
        }
      ],
      colCheckBoxes: ''
    }
  },

  computed: {
    ...mapState({
      stakeholder: state => state.stakeholders.subscriptions.stakeholder,
      stakeholderSubscriptions: state => state.stakeholders.subscriptions
    })
  },

  mounted() {
    let data = cloneDeep(this.stakeholderSubscriptions.subscriptions)
    if (!data || !data.length) return
    data.forEach(item => (item.decision = ''))
    this.subscriptions = data
  },

  methods: {
    toggleColCheckboxes(val) {
      if (this.colCheckBoxes === val) val = ''
      this.colCheckBoxes = val
      this.changeDecisionOfSubscriptionTo(val)
    },

    toggleCellCheckboxes(row, val) {
      if (row.decision === val) val = ''
      row.decision = val
      this.syncCellAndHeaderCheckboxes(val)
    },

    changeDecisionOfSubscriptionTo(value) {
      this.subscriptions = this.subscriptions.map(subscription => {
        subscription.decision = value
        return subscription
      })
    },

    syncCellAndHeaderCheckboxes(checkboxState) {
      const allCellCheckboxesAreEqual = this.subscriptions.every(s => s.decision === checkboxState)
      if (allCellCheckboxesAreEqual) this.colCheckBoxes = checkboxState
      else this.colCheckBoxes = ''
    },

    save() {
      let decisions = {}
      this.subscriptions.forEach(item => {
        if (item.decision !== '') decisions[item.id] = item.decision
      })
      let payload = {
        decisions: decisions
      }
      this.$store
        .dispatch('stakeholders/submitDecisions', {
          id: this.stakeholder.id,
          value: payload
        })
        .then(data => (this.subscriptions = data))
    }
  }
}
</script>

<style lang="scss" scoped>
.q-table thead th {
  padding: 7px 16px;
}
</style>
